import { Box } from '@breathelife/mui';
import { ReactElement } from 'react';
import { NavLink, useMatch } from 'react-router-dom';

import { FullColorGradient } from '@breathelife/types';

import Typography from '../../Components/Typography';
import { NavLinkButton } from './Styles';

type SidebarNavLinkProps = {
  to: string;
  text: string;
  icon: ReactElement;
  greyShade?: keyof FullColorGradient;
  activeColor?: string;
  hoverColor?: string;
};

export function SidebarNavLink(props: SidebarNavLinkProps): ReactElement {
  const { to, text, icon, greyShade, activeColor, hoverColor } = props;
  const match = useMatch({
    path: to,
    end: false,
  });

  return (
    <Box my={1}>
      <NavLinkButton component={NavLink} to={to} isActive={!!match} activeColor={activeColor} hoverColor={hoverColor}>
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Box lineHeight='0'>{icon}</Box>
          <Box>
            <Typography variant='small3' grey={greyShade ?? 100}>
              {text}
            </Typography>
          </Box>
        </Box>
      </NavLinkButton>
    </Box>
  );
}
